import { Box, PressableBox } from '@opendoor/bricks-next';

import { FiveUserImageRow } from 'components/shared/FiveUserImageRow';
import { IRenderTPWidget, RenderTrustpilotWidget } from 'components/shared/TrustpilotWidget';

export const TrustPilotWithUserImages = () => (
  <PressableBox
    analyticsName="homepage-trust-pilot-widget"
    aria-label="trust pilot review overview and link to them"
    href="https://www.trustpilot.com/review/opendoor.com"
    width={190}
    marginHorizontal="auto"
    overflow="hidden"
    rel="noopener"
    target="_blank"
    flexDirection="row"
    alignItems="center"
    rowGap="$2x"
    flexWrap="nowrap"
    position="relative"
    justifyContent="flex-start"
    $largerThanXS={{ width: 325 }}
    $largerThanSM={{ width: 365 }}
    $largerThanMD={{ marginLeft: 0 }}
    height={62}
  >
    <Box $smallerThanSM={{ display: 'none' }}>
      <FiveUserImageRow />
    </Box>
    <Box>
      <RenderTrustpilotWidget
        {...({
          fields: { title: '' },
          rawWidget: true,
          // overrides for custom/flex widget
          tpCommonDataOverride: {
            'data-template-id': '54197383fd9dceac42a68694',
            'data-token-desktop': 'cba266c7-0ba0-47f5-83c8-c4478b13cd3b',
            'data-token-mobile': '7c30b375-b0d9-493e-94cb-eac4ca18ad32',
            'data-style-size': 'XS',
            'data-text-color': 'dark',
            'data-headline': 'star',
            'data-background': 'none',
            'data-external-elements-color': 'dark',
            'data-style-height': '62',
            'data-style-width': '200',
          },
          hideFallback: true,
        } as IRenderTPWidget)}
      />
    </Box>
  </PressableBox>
);
